import React from "react"

function CampaignBanner(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { campaignTitle = "alt", campaignImageUrl, onClick } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div style={styles.column}>
      {campaignImageUrl && (
        <img
          alt={campaignTitle}
          onClick={onClick}
          style={styles.image}
          src={campaignImageUrl}
        />
      )}
    </div>
  )
}

// ----------------------------------------------------------------------------

const styles = {
  image: {
    width: "100%",
    minHeight: "150px",
    cursor: "pointer",
  },
}

export default CampaignBanner
